import React from 'react';

import { CalculatedAddress } from './variants/address.calculated.jsx';

export const AddressFieldsView = (props) => {
  return <CalculatedAddress {...props} />;
};
